interface AuthErrorLike {
  message?: string;
  status?: number;
  code?: string;
}

const RATE_LIMIT_MSG =
  "Too many reset requests. Please wait a few minutes before trying again.";

/** User-facing copy for Supabase password-reset failures (incl. 429 rate limits). */
export function formatPasswordResetError(error: AuthErrorLike): string {
  if (error.status === 429) return RATE_LIMIT_MSG;

  const message = error.message?.toLowerCase() ?? "";
  if (/rate limit|too many|security purposes|once every/.test(message)) {
    return RATE_LIMIT_MSG;
  }

  return error.message || "Failed to send reset link. Please try again.";
}
